// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1MsMd","approved":"Status_approved__3XZHU","rejected":"Status_rejected__ZH0pg","expired":"Status_expired__jNyN5","label":"Status_label__3gBYC"};